export default (inputMinutes:number):string => {
    if (!inputMinutes) {
        return '';
    }
    let hourLabel = 'Hour';
    let dayLabel = 'Day';
    let minuteLabel = 'Min';

    let result = '';

    const days = (inputMinutes / 60) / 24;
    const rDays = Math.floor(days);

    const hours = (inputMinutes / 60);
    const rHours = Math.floor(hours);

    const minutes = (hours - rHours) * 60;
    const rMinutes = Math.round(minutes);

    dayLabel = rDays > 1 ? `${dayLabel}s` : dayLabel;
    hourLabel = rHours > 1 ? `${hourLabel}s` : hourLabel;
    minuteLabel = rMinutes > 1 ? `${minuteLabel}s` : minuteLabel;

    if (rDays > 0) {
        return `${rDays} ${dayLabel}`;
    }

    result = rHours > 0 ? `${rHours} ${hourLabel}` : result;
    result = rMinutes > 0 ? `${result} ${rMinutes} ${minuteLabel}` : result;

    return result;
};
